import React from 'react';
import { AppLoginTemplate } from 'themes/modules/membership/pages';
import { setCurrentView } from 'core/utils';
import { AppLoginViewStore } from 'modules/membership/stores';

@setCurrentView(rootStore => new AppLoginViewStore(rootStore))
export default class AppLogin extends React.Component {
	render() {
		return <AppLoginTemplate {...this.props} />;
	}
}
